import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';
import { EcatalogService } from 'src/app/services/ecatalog.service';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.less']
})
export class CategoryComponent implements OnInit {
  category:string="";
  menuData:any[] = [];
  filteredMenuData: any[]=[];
  searchText = '';
  nodeSelectedKeys: string[] = [];
  isDealerPortal: boolean = false;
  @Output() categorySelected: EventEmitter<{ selectedKeys: string[]; nodeKey: string }> = new EventEmitter<{ selectedKeys: string[]; nodeKey: string }>();
  
  constructor(private ecatalogService:EcatalogService, private translate:TranslateService,
    private sharedData: SharedDataService) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
  }

  ngOnInit(): void {
    this.getCategorys();
  }
  getCategorys():void{
    this.ecatalogService.getCategorys({}).subscribe(result=>{
      this.menuData=result.rtnData;
      this.filteredMenuData = [
        {
          key: 'ORDER_ALL',
          title: this.translate.instant('ORDER_ALL'),
          id: 'ORDER_ALL',
          parentId: null,
          isLeaf: true,
          children: [],
        },
        ...this.transformNode(result.rtnData)
      ];
    })
  }
  handleTreeEvent(event:NzFormatEmitEvent): void {
    const node = event.node!;
    let selectedKeys = []
    this.nodeSelectedKeys = [node.key];
    if(node.key == 'ORDER_ALL'){
      this.categorySelected.emit(undefined);
      return;
    }else if(node['_children']?.length){
      selectedKeys = node['_children'].map((item: any) => item.key)
    }else{
      selectedKeys = [node.key]
    }
    this.categorySelected.emit({selectedKeys: selectedKeys, nodeKey: node.key});
    // if (environment.production) {
    //   const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    //   const customer = JSON.parse(localStorage.getItem('customer') || '{}');
    //   if (node['_children']?.length === 0 && node.parentNode) {
    //     (window as any).dataLayer.push({
    //       event: 'dp_ecat_cat_click',
    //       from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
    //       event_type: '',
    //       event_name: '',
    //       portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
    //       event_content: node.parentNode.key + "," + node.key,
    //     });
    //   } else {
    //     (window as any).dataLayer.push({
    //       event: 'dp_ecat_cat_click',
    //       from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
    //       event_type: '',
    //       event_name: '',
    //       portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
    //       event_content: node.key,
    //     });
    //   }
    // }
  }

  transformNode(list: any):any[] {
    if (!Array.isArray(list)) {
      return [];
    }
    return list.map((node: any) => ({ 
        key: node.categoryName, 
        title: node.categoryName, 
        id: node.categoryName,
        parentId: node.categoryName,
        isLeaf: !(node.categoryItems && node.categoryItems.length),
        children: this.transformNode(node.categoryItems),
      }));
  }
}
